export const environment = {
  production: true,
  apiBaseUrl: process.env["NX_API_BASE_URL"],
  matomoUrl: "https://3rdeyes.matomo.cloud/",
  matomoSiteId: 3
};
